import React from 'react';
import './Testimonials.css';

const Testimonials = () => {
  const testimonials = [
    {
      quote: "This system changed everything for our small farm. Installation was so simple, and we're saving so much water while growing better crops.",
      name: "Maria Santos",
      location: "Washington State"
    },
    {
      quote: "They did in 3 hours what would have taken us 2 days. Now we can focus on farming instead of complex installations.",
      name: "David Ochieng",
      location: "Idaho"
    },
    {
      quote: "Finally, drip irrigation that doesn't break our budget. The water savings alone paid for the system in the first season.",
      name: "Priya Patel",
      location: "India"
    }
  ];

  return (
    <section className="testimonials">
      <div className="container">
        <h2>Real Results from Real Farmers</h2>
        <div className="stats-highlight">
          <p className="stats-text">
            Farmers who use our system report a <strong>-42% decrease in water usage</strong>, <strong className="blue-text">-78% reduction in daily irrigation labor time</strong>, and an increase in Clash Royale XP as they now have increased time to conduct more "meaningful" and less menial tasks. The first two stats are real, the last one is assumed but defo realistic.
          </p>
        </div>
        
        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="testimonial-card">
              <div className="stars">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="fas fa-star"></i>
                ))}
              </div>
              <div className="quote-mark">❝</div>
              <p className="quote">"{testimonial.quote}"</p>
              <div className="author">
                <strong>{testimonial.name}</strong>
                <span>{testimonial.location}</span>
              </div>
            </div>
          ))}
        </div>
        
        <div className="cta-section">
          <h3>Join Other Satisfied Farmers!</h3>
          <p>Our robotic irrigation system is already transforming agriculture, helping farmers save water, reduce costs, and increase yields.</p>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
